import script from "./whatsappDoc.vue?vue&type=script&setup=true&lang=js"
export * from "./whatsappDoc.vue?vue&type=script&setup=true&lang=js"

import "./whatsappDoc.vue?vue&type=style&index=0&id=52b9c72b&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52b9c72b"]])

export default __exports__